import styled from 'styled-components'

export const QrCode = styled.div`
  display: flex;

  & canvas {
    width: 100%;
  }
`
